export class AppCookies {
  get cookies() {
    return document.cookie.split('; ').reduce((acc, cur) => {
      const cookieSeparatorIndex = cur.search(/=/)
      acc[cur.substring(0, cookieSeparatorIndex)] = cur.substring(cookieSeparatorIndex + 1)
      return acc
    }, {} as Record<string, string>)
  }

  getCookie(key: string) {
    return this.cookies[key]
  }
}
